import type { ApolloError } from "@apollo/client";

import { GqlPlannerV2TransportationMethod } from "~/__generated__/graphql/types.ts";
import { FieldworkerAvailabilityByDate } from "~/modules/fieldworker/components/FieldworkerAvailabilityDots";
import { GaiaExpandableMapMarker } from "~/modules/plannerV2/components/GaiaExpandableMapMarker";

import {
    GaiaExpandableMapMarkerFieldworkerAvailableTransportationMethodsFragment,
    GaiaExpandableMapMarkerFieldworkerAvailableTravelGroupsFragment,
    GaiaExpandableMapMarkerFieldworkerFragment,
} from "./fragments.generated";
import { GaiaExpandableMapMarkerFieldworkerBody } from "./GaiaExpandableMapMarkerFieldworkerBody";
import { GaiaExpandableMapMarkerFieldworkerHeader } from "./GaiaExpandableMapMarkerFieldworkerHeader";

export type GaiaExpandableMapMarkerFieldworkerProps = {
    fieldworker: GaiaExpandableMapMarkerFieldworkerFragment;
    availableTransportationMethods?: GaiaExpandableMapMarkerFieldworkerAvailableTransportationMethodsFragment[];
    availabilityByDate?: FieldworkerAvailabilityByDate;
    selectedDate: string;

    loading: boolean;
    isBeingAdded: boolean;

    isAssigned: boolean;
    availableTravelGroups: GaiaExpandableMapMarkerFieldworkerAvailableTravelGroupsFragment[];
    onAddToVisit: (transportationMethod: GqlPlannerV2TransportationMethod) => void;
    onAddToCarpool: ({ plannerTravelGroupId, fieldworkerId }: { plannerTravelGroupId: string; fieldworkerId: string }) => void;
    error?: ApolloError;
};

export function GaiaExpandableMapMarkerFieldworker({
    fieldworker,
    availableTransportationMethods,
    availabilityByDate,
    selectedDate,

    loading,
    error,
    isBeingAdded,

    isAssigned,
    availableTravelGroups,
    onAddToVisit,
    onAddToCarpool,
}: GaiaExpandableMapMarkerFieldworkerProps) {
    return (
        <GaiaExpandableMapMarker>
            <GaiaExpandableMapMarkerFieldworkerHeader
                fieldworker={fieldworker}
                availableTransportationMethods={availableTransportationMethods}
                availabilityByDate={availabilityByDate}
                selectedDate={selectedDate}
                loading={loading}
                isBeingAdded={isBeingAdded}
                isAssigned={isAssigned}
                onIconClick={onAddToVisit}
            />
            <GaiaExpandableMapMarkerFieldworkerBody
                fieldworker={fieldworker}
                availableTravelGroups={availableTravelGroups}
                onAddToVisitClick={onAddToVisit}
                onAddToTravelGroupClick={onAddToCarpool}
                isBeingAdded={isBeingAdded}
                error={error}
                availableTransportationMethods={availableTransportationMethods}
            />
        </GaiaExpandableMapMarker>
    );
}
